import { combineReducers } from "redux";

import {
  card_detail_info,
  card_list_info,
  card_search_result,
} from "pages/AccessManage/CardManage/Module/reducers/view_reducer";

export const accessServiceReducer = combineReducers({
  card_search_result,
  card_detail_info,
  card_list_info,
});
